<template><div><BlogPost :author="$frontmatter.author" :posted="parse($frontmatter.posted, 'y-M-d', new Date())" :heading="$frontmatter.heading">
<p class="d-docsite--paragraph">Hello everyone, the Dialtone team here with an important update, We'll be deprecating all <code v-pre>DtRecipe*</code> components in Dialtone in favor of standalone UI-Kit packages. Additionally a few recipes have been upgraded from recipes to core dialtone components.</p>
<p class="d-docsite--paragraph">Each kit is individually published to npm and can be installed independently:</p>
<div class="language-bash" data-highlighter="prismjs" data-ext="sh"><pre v-pre><code class="language-bash"><span class="line"><span class="token function">npm</span> <span class="token function">install</span> @dialpad/callbarkit</span>
<span class="line"><span class="token function">npm</span> <span class="token function">install</span> @dialpad/chatkit</span>
<span class="line"><span class="token function">npm</span> <span class="token function">install</span> @dialpad/formkit</span>
<span class="line"><span class="token function">npm</span> <span class="token function">install</span> @dialpad/navigationkit</span>
<span class="line"><span class="token function">npm</span> <span class="token function">install</span> @dialpad/workflowkit</span>
<span class="line"></span></code></pre>
</div><p class="d-docsite--paragraph">You may see the storybook for UI-Kits here: <a href="https://uikits.dialpad.com/" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">https://uikits.dialpad.com/</a></p>
<p class="d-docsite--paragraph">Here are the mappings from old components to new components. They are all functionally the same, however the deprecated DtRecipe components will no longer receieve updates.</p>
<p class="d-docsite--paragraph"><strong>Full migration mapping:</strong></p>
<table>
<thead>
<tr>
<th>Old (DtRecipe)</th>
<th>New</th>
<th>Package</th>
</tr>
</thead>
<tbody>
<tr>
<td><code v-pre>DtRecipeComboboxMultiSelect</code></td>
<td><code v-pre>DtComboboxMultiSelect</code></td>
<td><code v-pre>@dialpad/dialtone</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeComboboxWithPopover</code></td>
<td><code v-pre>DtComboboxWithPopover</code></td>
<td><code v-pre>@dialpad/dialtone</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeMotionText</code></td>
<td><code v-pre>DtMotionText</code></td>
<td><code v-pre>@dialpad/dialtone</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeCallbarButton</code></td>
<td><code v-pre>DpCallbarButton</code></td>
<td><code v-pre>@dialpad/callbarkit</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeCallbarButtonWithPopover</code></td>
<td><code v-pre>DpCallbarButtonWithPopover</code></td>
<td><code v-pre>@dialpad/callbarkit</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeCallbarButtonWithDropdown</code></td>
<td><code v-pre>DpCallbarButtonWithDropdown</code></td>
<td><code v-pre>@dialpad/callbarkit</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeGroupedChip</code></td>
<td><code v-pre>DpGroupedChip</code></td>
<td><code v-pre>@dialpad/callbarkit</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeTopBannerInfo</code></td>
<td><code v-pre>DpTopBannerInfo</code></td>
<td><code v-pre>@dialpad/callbarkit</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeAttachmentCarousel</code></td>
<td><code v-pre>DpAttachmentCarousel</code></td>
<td><code v-pre>@dialpad/chatkit</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeMessageInput</code></td>
<td><code v-pre>DpMessageInput</code></td>
<td><code v-pre>@dialpad/chatkit</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeContactInfo</code></td>
<td><code v-pre>DpContactInfo</code></td>
<td><code v-pre>@dialpad/chatkit</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeEditor</code></td>
<td><code v-pre>DpEditor</code></td>
<td><code v-pre>@dialpad/chatkit</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeEmojiRow</code></td>
<td><code v-pre>DpEmojiRow</code></td>
<td><code v-pre>@dialpad/chatkit</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeFeedItemPill</code></td>
<td><code v-pre>DpFeedItemPill</code></td>
<td><code v-pre>@dialpad/chatkit</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeFeedItemRow</code></td>
<td><code v-pre>DpFeedItemRow</code></td>
<td><code v-pre>@dialpad/chatkit</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeContactCentersRow</code></td>
<td><code v-pre>DtContactCentersRow</code></td>
<td><code v-pre>@dialpad/navigationkit</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeContactRow</code></td>
<td><code v-pre>DtContactRow</code></td>
<td><code v-pre>@dialpad/navigationkit</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeGeneralRow</code></td>
<td><code v-pre>DtGeneralRow</code></td>
<td><code v-pre>@dialpad/navigationkit</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeGroupRow</code></td>
<td><code v-pre>DtGroupRow</code></td>
<td><code v-pre>@dialpad/navigationkit</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeUnreadPill</code></td>
<td><code v-pre>DtUnreadPill</code></td>
<td><code v-pre>@dialpad/navigationkit</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeCallbox</code></td>
<td><code v-pre>DtCallbox</code></td>
<td><code v-pre>@dialpad/navigationkit</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeSettingsMenuButton</code></td>
<td><code v-pre>DtSettingsMenuButton</code></td>
<td><code v-pre>@dialpad/navigationkit</code></td>
</tr>
<tr>
<td><code v-pre>DtRecipeIvrNode</code></td>
<td><code v-pre>DtIvrNode</code></td>
<td><code v-pre>@dialpad/workflowkit</code></td>
</tr>
</tbody>
</table>
<p class="d-docsite--paragraph">CSS classes also change: <code v-pre>dt-recipe-*</code> → <code v-pre>dp-*</code></p>
<p class="d-docsite--paragraph">You will also need to import the CSS for each kit you install:</p>
<div class="language-css" data-highlighter="prismjs" data-ext="css"><pre v-pre><code class="language-css"><span class="line"><span class="token atrule"><span class="token rule">@import</span> <span class="token string">'@dialpad/callbarkit/vue3/css'</span><span class="token punctuation">;</span></span></span>
<span class="line"><span class="token atrule"><span class="token rule">@import</span> <span class="token string">'@dialpad/chatkit/vue3/css'</span><span class="token punctuation">;</span></span></span>
<span class="line"><span class="token atrule"><span class="token rule">@import</span> <span class="token string">'@dialpad/formkit/vue3/css'</span><span class="token punctuation">;</span></span></span>
<span class="line"><span class="token atrule"><span class="token rule">@import</span> <span class="token string">'@dialpad/navigationkit/vue3/css'</span><span class="token punctuation">;</span></span></span>
<span class="line"><span class="token atrule"><span class="token rule">@import</span> <span class="token string">'@dialpad/workflowkit/vue3/css'</span><span class="token punctuation">;</span></span></span>
<span class="line"></span></code></pre>
</div><p class="d-docsite--paragraph"><strong>Timeline:</strong></p>
<ul class="d-docsite--unordered-list">
<li class="d-docsite--list-element"><code v-pre>DtRecipe*</code> components will remain available until the next major Dialtone release (Q2 2026), but <strong>will no longer receive updates</strong></li>
<li class="d-docsite--list-element">Migrate before then to stay current with improvements and bug fixes</li>
</ul>
<p class="d-docsite--paragraph"><strong>Automated migration script:</strong></p>
<p class="d-docsite--paragraph">We provide a Node.js script that automatically updates your codebase — no manual find-and-replace needed. It handles:</p>
<ul class="d-docsite--unordered-list">
<li class="d-docsite--list-element">Import statement rewrites (splits <code v-pre>@dialpad/dialtone/vue3</code> imports into the correct new packages)</li>
<li class="d-docsite--list-element">PascalCase component name replacements in JS/TS/Vue script blocks</li>
<li class="d-docsite--list-element">Kebab-case component name replacements in Vue templates</li>
<li class="d-docsite--list-element">CSS class prefix changes (<code v-pre>dt-recipe-*</code> → <code v-pre>dp-*</code> / <code v-pre>dt-*</code>)</li>
</ul>
<p class="d-docsite--paragraph">Download and run it with:</p>
<div class="language-bash" data-highlighter="prismjs" data-ext="sh"><pre v-pre><code class="language-bash"><span class="line"></span>
<span class="line"><span class="token comment"># Preview changes without writing files</span></span>
<span class="line"></span>
<span class="line"><span class="token function">curl</span> <span class="token parameter variable">-s</span> <span class="token operator">&lt;</span>https://raw.githubusercontent.com/dialpad/dialtone/staging/scripts/migrate-recipes-to-uikits.mjs<span class="token operator">></span> <span class="token operator">|</span> <span class="token function">node</span> - /path/to/your/project --dry-run</span>
<span class="line"></span>
<span class="line"><span class="token comment"># Apply changes</span></span>
<span class="line"></span>
<span class="line"><span class="token function">curl</span> <span class="token parameter variable">-s</span> <span class="token operator">&lt;</span>https://raw.githubusercontent.com/dialpad/dialtone/staging/scripts/migrate-recipes-to-uikits.mjs<span class="token operator">></span> <span class="token operator">|</span> <span class="token function">node</span> - /path/to/your/project</span>
<span class="line"></span></code></pre>
</div><p class="d-docsite--paragraph">After running, install the new packages your project needs and verify with your lint + test suite.</p>
<p class="d-docsite--paragraph">This migration has already been performed on the Dialpad (ubervoice) application.</p>
<p class="d-docsite--paragraph"><strong>What you need to do:</strong></p>
<ul class="d-docsite--unordered-list">
<li class="d-docsite--list-element"><code v-pre>npm install</code> whichever ui-kits packages you need</li>
<li class="d-docsite--list-element">import the css for whichever packages you need</li>
<li class="d-docsite--list-element">Run the migration script to migrate your project to the new components</li>
<li class="d-docsite--list-element">Any changes you wish to make to <code v-pre>DtRecipe*</code> components in Dialtone should now be made in <a href="https://github.com/dialpad/dialpad-uikits" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">dialpad-uikits</a> instead.</li>
</ul>
<p class="d-docsite--paragraph">Thanks! Please let us know in #dialtone if you have any issues.</p>
</BlogPost>
</div></template>


<script setup>
import BlogPost from '@baseComponents/BlogPost.vue';
import { parse } from 'date-fns';
</script>